import { QUICK_NAV_ICON_SIZE, QUICK_NAV_ITEMS } from './shell.constants.js';
import { EmojiIcon } from '../../ui/EmojiIcon.jsx';

/**
 * Sticky pill bar that jumps to a dashboard section.
 *
 * Items come from `QUICK_NAV_ITEMS`, keyed by their section id, never by array
 * index. Scrolling is delegated to the caller so this component does no DOM work
 * of its own and stays testable.
 *
 * @param {{onNavigate: (sectionId: string) => void}} props
 */
export function QuickNav({ onNavigate }) {
  return (
    <nav className="quick-nav" aria-label="Jump to section">
      {QUICK_NAV_ITEMS.map(({ sectionId, emoji, label }) => (
        <button
          key={sectionId}
          type="button"
          className="chip"
          onClick={() => onNavigate(sectionId)}
        >
          <EmojiIcon emoji={emoji} size={QUICK_NAV_ICON_SIZE} />
          {label}
        </button>
      ))}
    </nav>
  );
}
